import { useMarketingVoucherI18nFormModelContext } from "../../../../../../model";
import { useMarketingExistingVoucherI18nFormModelContext } from "../../../../context";

export const useUpdateButton = () => {
	const { viewModel } = useMarketingVoucherI18nFormModelContext();
	const { onUpdate } = useMarketingExistingVoucherI18nFormModelContext();

	const isValid = !viewModel.hasError && viewModel.isDirty;

	return {
		isValid,
		onUpdate,
	};
};
